import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { MediaItemEntity } from '../components/media-list/media-item.entity';
import { MediaListEntity } from '../components/media-list/media-list.entity';
import { featureSelector, MediaRootState } from './feature.store';
import { MediaOriginalSliceState, MediaSliceKey } from './media.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[MediaSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mediaById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class MediaSelector {
	public constructor(private readonly store: Store<MediaRootState>) {}

	private get state(): Observable<MediaOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getMediaList$(): Observable<MediaListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public getSuccessDeleteMedia$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getMedia$(id: number): Observable<MediaItemEntity | undefined> {
		return this.store.pipe(select(mediaById(id)));
	}

	public getSelectedMedias$(
		selected: Array<string>
	): Observable<Array<MediaItemEntity>> {
		return this.getMediaList$().pipe(
			map((list) =>
				selected.reduce<Array<MediaItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
